"use client";
import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#394e2d",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#fae627",
      contrastText: "#394e2d",
    },
    background: {
      default: "#f5f5fa",
    },
  },
  typography: {
    fontFamily: "var(--font-poppins)",
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          borderRadius: 4,
          fontWeight: 500,
          fontSize: "18px",
          boxShadow: "none",
          whiteSpace: "nowrap",
        },
      },
    },
  },
});

export default theme;
